export default __webpack_public_path__ + "static/allrings-88b4c3e6acbdc5841cdeec0a86904c03.png";